

/**
 * @class
 * DataConverter model
 */
export default class DataConverter {

    /**
     * @constructor
     * @param {String} id Data converter ID
     * @param {string} label Data converter label
     * @param {Date} createTimestamp Data converter creating timestamp
     * @param {Date} updateTimestamp Data converter last updating timestamp
     * @param {String} converter Data converter logic string
     */
    constructor(
      id,
      label,
      createTimestamp,
      updateTimestamp,
      converter
    ){ 
      this._id = id
      this._label = label
      this._createTimestamp = createTimestamp
      this._updateTimestamp = updateTimestamp
      this._converter = converter
    }

    get id(){
      return this._id
    }
    set id(value){
        this._id = value
    }

    get label(){
        return this._label
    }
    set label(value){
      this._label = value
    }

    get createTimestamp(){
        return this._createTimestamp
    }
    set createTimestamp(value){
        this._createTimestamp = value
    }

    get updateTimestamp(){
        return this._updateTimestamp
    }
    set updateTimestamp(value){
        this._updateTimestamp = value
    }

    get converter(){
      return this._converter
    }
    set converter(value){
        this._converter = value
    }
  }